import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useContext } from "react";
import { UserContext } from "../../context";

const useInspectionQuestions = () => {
  const { uploadPhoto, savePhotoUrl, get, ...others } =
    useColection<InspectionQuestion>("inspection-checklist");
  const getByCompany = (companyId: string) => {
    return get([where("companyId", "==", companyId)]);
  };

  return { ...others, get: getByCompany };
};

export default useInspectionQuestions;
